import React from 'react';

import Botones from '../../components/UI/botonera/headerBotones.js';
import CajaTexto from '../../components/UI/cajaTexto/cajaTexto.jsx';

function EtiquetasReportesInt(props) {
    return (
        <>
            <div className="col-md-12">
                <div className='row'>
                    <div className="col-md-6">
                        <h1>{props.titulo}</h1>
                    </div>
                    <div className="col-md-6 text-right">
                        <div className="acciones">
                            <Botones
                                botones={props.botones}
                            />
                        </div>
                    </div>
                </div>

                <div className="content">
                    <div className="content-box box-primary">
                        <div className='row'>
                            <div className='row'>
                            <CajaTexto col="6" id="IngresosNoDeducibles" type="text" label={props.Datos.IngresosNoDeducibles.attributes.label} value={props.Datos.IngresosNoDeducibles.value} attributes={props.Datos.IngresosNoDeducibles.attributes} onChangeInput={props.onChangeInput} />
                            <CajaTexto col="6" id="EgresosNoDeducibles" type="text" label={props.Datos.EgresosNoDeducibles.attributes.label} value={props.Datos.EgresosNoDeducibles.value} attributes={props.Datos.EgresosNoDeducibles.attributes} onChangeInput={props.onChangeInput} />
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <br />
        </>
    );
}
export default EtiquetasReportesInt;